import React from "react";
import Skeleton from "react-loading-skeleton";
const SkeletonVideoPlayer = () => {
  return (
    <ul className="list-unstyled m-0">
      {Array(1)
        .fill()
        .map((item, index) => (
          <li key={index}>
            <Skeleton height={500} />
          </li>
        ))}
    </ul>
  );
};
export default SkeletonVideoPlayer;
